import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import MoreTimeRoundedIcon from '@mui/icons-material/MoreTimeRounded'
import { Box, Typography } from '@mui/material'
import Button from '@mui/material/Button'

export const RequestAppointmentButton = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const initiateRequestAppointment = () => {
    navigate('/request-appointment')
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        width: '100%',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#ffffff',
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: '100%',
        }}
      >
        <Typography align="center" variant="subtitle2">
          {t("Can't find a time that works for you?")}
        </Typography>
      </Box>
      <Button
        aria-label="request appointment"
        color="primary"
        data-testid="request-appointment-button"
        fullWidth
        onClick={initiateRequestAppointment}
        startIcon={<MoreTimeRoundedIcon />}
        variant="outlined"
      >
        {t('Request an appointment')}
      </Button>
    </Box>
  )
}
